import React from "react";
import ReactDOMServer from "react-dom/server";

function InvoiceFooterSectionStatic(data) {
  const staticContent = (
    <div className="w-full flex flex-col mt-10 px-4">
      <div className="w-full justify-between gap-4 flex">
        <div className="flex flex-1 flex-col gap-1 w-1/4">
          <span className="text-lg font-bold">{data?.companyName}</span>
          <span className="text-sm">{data?.companyAddress}</span>
          <span className="text-sm">{data?.email}</span>
        </div>
        <div className="flex flex-1 flex-col gap-1 w-1/3">
          <span className="text-sm font-semibold">Payment Instructions</span>
          <span className="text-xs text-gray-400">
            Please make payment using the bank details below or using the
            payment link.
          </span>
          <span className="text-sm mt-2 text-gray-500">Bank details</span>
          <span className="text-sm">Access Bank | 1234567890</span>
          <span className="text-sm mt-2 text-gray-500">Payment link</span>
          <span className="text-sm">{data?.paymentLink}</span>
        </div>
        <div className="flex flex-1 flex-col w-1/3">
          <span className="text-sm font-semibold">Additional Notes</span>
          <span className="text-sm text-gray-500">{data?.notes}</span>
        </div>
      </div>
    </div>
  );

  return ReactDOMServer.renderToStaticMarkup(staticContent);
}

export default InvoiceFooterSectionStatic;
